module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp vux-previewer",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden"
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _vm._v(" "), _vm._t("button-after"), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._v(" "), _vm._t("button-before"), _vm._v(" "), _vm._m(1)], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-063575e9"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/previewer/index.vue
// module id = 184
// module chunks = 1